module.exports = __webpack_public_path__ + "img/institution.d8b9fd36.svg";